/**
 * Learn more about palette customization
 * https://material-ui.com/customization/palette/
 *
 * Default theme palette values provided by MUI
 * https://material-ui.com/customization/default-theme/?expand-path=$.palette
 */

export default {
	primary: {
		main: '#ff422f',
	},
	secondary: {
		main: '#1a58b8',
	},
	more: {
		white: '#ffffff',
		jetBlack: '#2d2d2d',
		greenFlash: '#87d155',
		tree: '#58a722',
		tarnishedSilver: '#77797e',
		jupiter: '#e2e2e2',
		blueRinse: '#b6bfc6',
		drWhite: '#fafbfb',
		wax: '#2b2b2b',
		eclipse: '#3f3f3f',
		sunGlow: '#ffcb3f',
		mystic: '#e4e8f0',
		error: '#f44336',
		saffron: '#f8d237',
		cloudyBlue: '#b6bfc6',
	},
	divider: 'rgba(0,0,0,0.10)',
	text: {
		primary: '#2d2d2d',
		secondary: '#b6bfc6',
	},
	action: {
		hover: 'rgba(0,0,0,0)',
		hoverOpacity: 0,
	},
};
